var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import { toJSON, useAlert } from "uxp/components";
import * as CopilotIcon from '@images/copilot.svg';
import { applyCopilot } from "@query-engine-service";
import { prepareQuery } from "@utils";
import { Icon } from "uxp/components";
import './Copilot.scss';
export const Copilot = props => {
    const [expanded, setExpanded] = useState(false);
    const [copilotText, setCopilotText] = useState('');
    const [loading, setLoading] = useState(false);
    const alerts = useAlert();
    const $L = (key) => props.context.uxpContext.$L(key);
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            runCopilot();
        }
    };
    function runCopilot() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            try {
                setLoading(true);
                let r = yield applyCopilot(props.context, props.query, copilotText);
                let p = typeof (r === null || r === void 0 ? void 0 : r.pipeline) == 'object' ? r === null || r === void 0 ? void 0 : r.pipeline : toJSON((r === null || r === void 0 ? void 0 : r.pipeline) || '');
                if (!p) {
                    alert($L('lqe.cop.error-general'));
                    (_b = (_a = props.context.uxpContext).trackAnalytics) === null || _b === void 0 ? void 0 : _b.call(_a, 'ai', {
                        message: copilotText,
                        success: false
                    });
                    return;
                }
                (_d = (_c = props.context.uxpContext).trackAnalytics) === null || _d === void 0 ? void 0 : _d.call(_c, 'ai', {
                    message: copilotText,
                    success: true
                });
                if (p.steps && p.sources) {
                    props.onQueryChanged(yield prepareQuery(props.context, p));
                    setCopilotText('');
                }
                else {
                    alert($L('lqe.cop.error-trouble'));
                    console.log(p, copilotText);
                }
            }
            catch (e) {
                console.log(e);
                alert($L('lqe.cop.error-retry'));
            }
            finally {
                setLoading(false);
            }
        });
    }
    const trigger = React.createElement("div", { className: "lqe-copilot-trigger-ce967cbb", onClick: () => setExpanded(e => !e) },
        React.createElement("img", { src: CopilotIcon.default, alt: "" }));
    if (!expanded)
        return trigger;
    return React.createElement(React.Fragment, null,
        trigger,
        React.createElement("div", { className: "global-copilot-ce967cbb" },
            React.createElement("div", { className: "gc-label-ce967cbb" }, $L('lqe.cop.title')),
            React.createElement("textarea", { placeholder: $L('lqe.cop.placeholder'), onKeyDown: handleKeyDown, disabled: loading, value: copilotText, onChange: e => setCopilotText(e.target.value) }),
            React.createElement("div", { className: "global-copilot-button-ce967cbb", onClick: () => __awaiter(void 0, void 0, void 0, function* () { return yield runCopilot(); }), title: $L('lqe.cop.submit') },
                React.createElement(Icon, { icon: loading ? 'fas dot-circle' : 'fas arrow-up' }))));
};
